var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseBackdropOverlay',_vm._b({attrs:{"visible":_vm.visible}},'BaseBackdropOverlay',_vm.options,false))}
var staticRenderFns = []

export { render, staticRenderFns }